import { TerminateSteps } from './types'

export const TERMINATE_FLOW = [
  TerminateSteps.CHURN,
  TerminateSteps.METER_DETAILS,
  TerminateSteps.REFERRAL,
  TerminateSteps.OVERVIEW,
  TerminateSteps.DONE
]
